if (!customElements.get('slider-component')) {
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.getAttribute('data-section-id');
      this.slider = this.querySelector('.swiper');
      if (!this.slider) return;
      this.initSlider();
      this.initVideoPlaying();
    }

    initSlider() {
      const swiper = new Swiper(`.swiper--${this.sectionId}`, {
        slidesPerView: 'auto',
        grabCursor: true,
        slidesOffsetAfter: 12,
        noSwiping: true,
        noSwipingClass: 'swiper-no-swiping',
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          1025: {
            slidesOffsetAfter: 24,
          },
        },
      });
    }

    initVideoPlaying() {
      const videoSlides = this.querySelectorAll('[data-video]');
      if (videoSlides.length === 0) return;
      videoSlides.forEach((slide) => {
        const videos = slide.querySelectorAll('video');
        if (videos.length === 0) return;
        if (videos.length === 1) {
          this.observVideo(videos[0]);
        } else {
          const matchesBreakpoint = (video) => (window.innerWidth > 1024 && video.classList.contains('image-desktop')) || (window.innerWidth <= 1024 && video.classList.contains('image-mobile'));
          videos.forEach((video) => {
            if (matchesBreakpoint(video)) {
              this.observVideo(video);
            }
          });
        }
      });
    }

    observVideo(video) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
          }
        });
      });
      observer.observe(video);
    }
  }

  customElements.define('slider-component', SliderComponent);
}
